module.exports = __webpack_public_path__ + "static/img/oxb.3ef651e4.jpeg";